import React, {useState} from 'react';
import {Organization} from "../../models/organization";
import {useCapability} from "../../auth/CapabilityContext";
import {fetchUserCapabilities} from "../../api/user-capability-functions";

const OrganizationContext = React.createContext<[Organization | undefined, (o: Organization) => Promise<void>]>((null as any));

export interface WithOrganization {
    currentOrganization: Organization;
}

function useOrganization() {
    const context = React.useContext(OrganizationContext);
    if (!context)
        throw new Error('useOrganization must be used within an OrganizationContext Provider')
    return context;
}

const OrganizationProvider = (props: any) => {
    const [currentOrganization, setCurrentOrganization] = useState<Organization>();
    const {setCapabilities} = useCapability();

    const setOrganization = async (organization: Organization) => {
        setCurrentOrganization(organization);
        const capabilities = await fetchUserCapabilities(organization.id);
        setCapabilities(capabilities);
    }

    return (
        <OrganizationContext.Provider value={[currentOrganization, setOrganization]}>
            {props.children}
        </OrganizationContext.Provider>
    )
}

export {OrganizationProvider, useOrganization};
